import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import PageHeader from '../../Components/PageHeader/PageHeader';

const ImportantLinks = () => {
    return (
        <>
            <PageHeader
                title="Important Links"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Important Links' }
                ]}
            />
            <div className="container py-5">
                <h2 className="mb-4">Important Links</h2>

                <ul>
                    <Link to="https://spa.ac.in/" target='_blank'>
                        <li>
                            <h4>
                                School of Planning and Architecture (SPA)
                            </h4>
                        </li>
                    </Link>
                    <li className='mt-4'>
                        <h4>
                            Ministry of Housing and Urban Affairs
                        </h4>
                    </li>
                    <ul>
                        <Link to="https://amrut.mohua.gov.in/" target='_blank'>
                            <li>
                                <h4>
                                    Amrut 2.0
                                </h4>
                            </li>
                        </Link>

                        <Link to="https://mohua.gov.in/" target='_blank'>
                            <li>
                                <h4>
                                    Ministry of Housing and Urban Affairs
                                </h4>
                            </li>
                        </Link>
                    </ul>
                </ul>

            </div>
        </>
    );
};

export default ImportantLinks;